module.exports = __webpack_public_path__ + "static/media/text_in_circle.ff5662be.png";